import { render, staticRenderFns } from "./ProductImageGalleryDialog.vue?vue&type=template&id=78723bd4&scoped=true"
import script from "./ProductImageGalleryDialog.vue?vue&type=script&lang=js"
export * from "./ProductImageGalleryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78723bd4",
  null
  
)

export default component.exports